import { useEffect, useRef } from "react";
import { toast } from "sonner";

export const useToast = (data: {
  pendingToast?: { type: string; message: string };
}) => {
  const prevToastRef = useRef<{ type: string; message: string } | null>(null);

  useEffect(() => {
    if (data.pendingToast) {
      const prevToast = prevToastRef.current;
      const currentToast = data.pendingToast;

      if (
        !prevToast ||
        prevToast.type !== currentToast.type ||
        prevToast.message !== currentToast.message
      ) {
        if (currentToast.type === "error") {
          toast.error(currentToast.message);
        } else if (currentToast.type === "success") {
          toast.success(currentToast.message);
        }

        prevToastRef.current = currentToast;
      }
    }
  }, [data.pendingToast]);
};
